export var SocialLoginProvider;
(function(SocialLoginProvider) {
    SocialLoginProvider[SocialLoginProvider["Google"] = 4] = "Google";
    SocialLoginProvider[SocialLoginProvider["Apple"] = 7] = "Apple";
    SocialLoginProvider[SocialLoginProvider["Facebook"] = 8] = "Facebook";
    SocialLoginProvider[SocialLoginProvider["Test"] = 5] = "Test";
})(SocialLoginProvider || (SocialLoginProvider = {}));
